import { render, staticRenderFns } from "./PageConfirmation.vue?vue&type=template&id=6747b900"
import script from "./PageConfirmation.vue?vue&type=script&lang=js"
export * from "./PageConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports